export default "__VITE_ASSET__DPepeFw5__"